import { NoteStorageType } from 'src/common/store/notebook/NoteState';

export const getTabId = (storageType: NoteStorageType, name: string) => {
  return `${storageType}-${name}`;
};

export const getUniqueTabNameForStorageType = (
  noteIds: Set<string>,
  storageType: NoteStorageType,
  name: string
) => {
  const baseNoteId = getTabId(storageType, name);
  let uniqueNoteId = baseNoteId;
  let index = 0;
  while (noteIds.has(uniqueNoteId)) {
    index += 1;
    uniqueNoteId = `${baseNoteId}-${index}`;
  }

  return index ? `${name}-${index}` : name;
};
